<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import ErrorMessage from "../../components/error-message";

/**
 * Invoice-detail component
 */
export default {
    components: { ErrorMessage,Layout, PageHeader },
    data() {
        return {
            errorMessage: "",
            title: "Profile",
            items: [
                {
                    text: "B2c User",
                    href: "/"
                },
                {
                    text: "Profile",
                    active: true
                }
            ],
            errors: null,
            userUuid:"",
            user:"",
            status:"",
            visible:false,
            message:"",
        };
    },
    created() {
        this.userUuid = this.$route.params.id;
    },
    mounted() {
        this.getInvoiceDetail();
    },
    methods: {
        onClose(){
            this.visible=false;
        },
        async getInvoiceDetail() {
            try {
                axios
                    .post("/api/user/b2c/" + this.userUuid, {
                        accessToken: localStorage.getItem("access_tocken"),
                    })
                    .then((response) => {
                        if (response.data.status) {
                            this.user=response.data.data;
                        } else {
                            var str = response.data.message;
                            var jsonParse = JSON.parse(str);
                            this.errorCheck(jsonParse);
                        }
                    })
                    .catch((error) => {
                        console.log(error.message);
                    });
            } catch (err) {
                console.log(err);
            }
        },
        errorCheck(obj) {
            if(obj.statusCode == 403){
                this.visible=true;
                this.message="Access Permission Denied";
                this.errors = obj.message;
            }else if (obj.error) {
                this.errors = obj.message;
            } else if (obj.message == "Token has expired") {
                this.$swal.fire({
                    title: 'LogOut!',
                    text: 'Token Has Expired',
                    icon: 'error',
                    toast:'true',
                    position: 'top-end',
                });
                this.$router.push({ name: "logout" });
            } else if (
                obj.message !== "Token has expired" &&
                obj.message !== "The given data was invalid."
            ) {
                this.errors = obj.message;
            } else if (obj.message == "The given data was invalid.") {
                this.errors = obj.errors;
            } else {
                this.flashMessage.show({
                    time: 5000,
                    status: "error",
                    title: "Error",
                    message: "Problem in data save",
                });
            }
        },
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <div>
                            <table>
                                <tr>
                                    <td>
                                        <label>First Name</label>
                                    </td>
                                    <td>
                                        {{user.first_name}}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Last Name</label>
                                    </td>
                                    <td>
                                       {{user.last_name}}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Gender</label>
                                    </td>
                                    <td>
                                        {{user.gender}}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Profile Picture</label>
                                    </td>
                                    <td>
                                        <img class="b2c_display_pic" v-bind:src="user.display_picture" alt="profile pic">
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Email</label>
                                    </td>
                                    <td>
                                        {{user.email}}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Phone Number</label>
                                    </td>
                                    <td>
                                        {{user.phone_code}} {{user.phone_number}}
                                    </td>
                                </tr>
                                <tr v-if="user.user_wallet!=null">
                                    <td>
                                        <label>Balance</label>
                                    </td>
                                    <td>
                                        {{user.user_wallet.main_balance}}
                                    </td>
                                </tr>
                                <tr v-if="user.user_wallet!=null">
                                    <td>
                                        <label>Currency</label>
                                    </td>
                                    <td>
                                        {{user.user_wallet.currency}}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Status</label>
                                    </td>
                                    <td>
                                        {{user.status}}
                                    </td>
                                </tr>
                            </table>
                            <br>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <!-- end row -->
    </Layout>
</template>
<style scoped>
table>tr>td{
    width:30%;
    height:45px;
}
.b2c_display_pic{
    width:100px;
}
</style>

